import { fabric } from "fabric";
import { arrangeObjectStack } from "@/canvas-api/ArrangeObjectStack";
import useDrawLabel from "@/composables/useDrawLabel";

export const handleGuidelines = async (canvas: fabric.Canvas, guidelineState: boolean) => {
  if (guidelineState) {
    const canvasObjects = canvas.getObjects();

    let i = 0;
    while (canvasObjects[i]) {
      if (canvasObjects[i].name === "labelCanvas" || canvasObjects[i].name === "actualLabelSize") {
        canvas.remove(canvasObjects[i]);
      }

      i++;
    }

    await useDrawLabel(canvas);
    arrangeObjectStack(canvas);
  } else {
    const canvasObjects = canvas.getObjects();

    //We do this because when iterating with an array and removing, it reduces size of array
    //as you iterate making the iteration complete before actually removing all safeZone lines
    let i = 0;
    while (canvasObjects[i]) {
      if (canvasObjects[i].name === "bleedLine" || canvasObjects[i].name === "safeZone") {
        canvas.remove(canvasObjects[i]);
      }

      i++;
    }
  }
};
